/* eslint-disable */


/**
 * Create styles for `<KeyValueMultiLineField />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<KeyValueMultiLineField />` styles
 */
const keyValueMultiLineFieldStyles = ({ theme }) => ({
  inputMultiline: {
    color: `initial`,
  },
  inputRoot: {
    fontSize: theme.typography.fontSize,
  },
});

export default keyValueMultiLineFieldStyles;
